'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useQuery } from '@tanstack/react-query';
import { usePostHogBoolFlag } from '@workspace/analytics/posthog/feature-flags-client';
import { getOrganisationsByUserIds } from '@/actions/organisation';
import { useAuthStore } from '@/stores/authStore';

export function useCanShowMultiOrganisationSwitcher(): boolean {
  const showMultiOrgs = usePostHogBoolFlag('show-multi-orgs', false);
  const user = useAuthStore((state) => state.user);
  const userId = user?.user.id;

  const { data: organisationsResponse } = useQuery({
    queryKey: ['organisations-by-user-ids', userId],
    queryFn: () => getOrganisationsByUserIds(userId ? [userId] : []),
    enabled: !!userId && showMultiOrgs,
    staleTime: 10 * 60 * 1000,
  });

  if (!showMultiOrgs) {
    return false;
  }

  return (organisationsResponse?.data?.length ?? 0) >= 2;
}
